import Tile from '@/components/tile/Tile'
import AdContent from './AdContent'

export default function InvTileAd(props) {
  
  return <Tile {...props}>
    <AdContent {...props}></AdContent>
  </Tile>
  
  
}